import(/* webpackMode: "eager", webpackExports: ["ClientOnlyStaticRootLayout"] */ "/app/src/app/(dynamic-root)/(static-root)/_client-only/index.js");
